<template>
  <VTimeline :items="timelineItems" extraClass="contacts-activity-timeline" />
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import moment from "moment";

import {
  ActivityTrackingOrder,
  ActivityTrackingLabelsMap,
} from "@/constants/common";

// components
import VTimeline from "@/components/VTimeline";
import { formatMomentDT } from "@/utils/util";

export default Vue.component("ContactsActivityTimeline", {
  props: {
    activityItems: VueTypes.object
  },

  components: {
    VTimeline
  },

  computed: {
    timelineItems() {
      const { latestStatus } = this.activityItems;
      const firstStatus = ActivityTrackingOrder[0];
      // const lastStatus =
      //   ActivityTrackingOrder[ActivityTrackingOrder.length - 1];

      let statusList = [
        {
          title: ActivityTrackingLabelsMap[firstStatus],
          status: latestStatus === firstStatus ? "current" : "complete",
          time: this.getFormattedDt(this.activityItems[firstStatus])
        }
      ];

      // activity has been just processed
      if (latestStatus === firstStatus) {
        return [
          ...statusList,
          {
            title: "Processed for Delivery",
            status: "future"
          }
        ];
      }

      // activity has been delivered or at least processed for delivery
      // if (latestStatus === lastStatus) {
      //   return [
      //     ...statusList,
      //     {
      //       title: "Processed for Delivery",
      //       status: "current",
      //       time: this.getFormattedDt(this.activityItems[lastStatus])
      //     }
      //   ];
      // }

      const sliceCount = latestStatus === "processed_for_delivery_at" ? 1 : 2;

      const statusToDisplay = ActivityTrackingOrder.slice(
        1,
        ActivityTrackingOrder.indexOf(latestStatus) + sliceCount
      );

      let currentReached = false;

      for (let key of statusToDisplay) {
        const isCurrent = latestStatus === key;

        if (isCurrent) {
          currentReached = true;
        }

        statusList.push({
          title: ActivityTrackingLabelsMap[key],
          status: isCurrent
            ? "current"
            : currentReached
            ? "future"
            : "complete",
          time: this.activityItems[key]
            ? this.getFormattedDt(this.activityItems[key])
            : ""
        });
      }

      return statusList;
    }
  },

  methods: {
    getFormattedDt(time) {
      return formatMomentDT(moment(time));
    }
  }
});
</script>

<style lang="scss">
.v-timeline.contacts-activity-timeline {
  width: 100%;
}
</style>
